import { useState } from 'react';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import ErrorMessage from '../../../../../Components/Errors/ErrorMessage';
import { Form, Text } from '../../../../../Components/Form';
import RemoveModal from '../../../../../Components/Modal/RemoveModal';
import {
  isValidIranianNationalCode,
  serverErrorHandler,
} from '../../../../../Utils/Helpers';
import CoaceshList from './CoachesList';
import SupervisorsList from './SupervisorsList';

const validationSchema = Yup.object({
  nat_code: Yup.string()
    .required('کد ملی الزامی است')
    .min(10, 'کد ملی باید 10 رقم باشد.')
    .max(10, 'کد ملی باید 10 رقم باشد.')
    .test(
      'nat_code',
      ('nat_code', 'فرمت کد ملی وارد شده اشتباه است'),
      (value) => {
        if (value == '0000000000') {
          return true;
        }

        return isValidIranianNationalCode(value);
      },
    ),
});

const Step2 = ({
  get,
  success,
  navigate,
  error,
  errors,
  context,
  setActiveNextLevel,
}) => {
  const [loading, setLoading] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [listLoading, setListLoading] = useState(false);
  const [type, setType] = useState(1);

  const onSubmit = async (values) => {
    setLoading(true);
    const url =
      type === 1
        ? `/coach/${values.nat_code}`
        : `/user/search/${values.nat_code}?competition_id=${context?.competition?.id}&age=0&supervisor=true`;
    await get(
      url,
      (res) => {
        const { data } = res;
        context.user = data;
        // setActiveNextLevel(true);
        setServerErrors({});
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        if (err?.status === 422 || err.status === 400) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error('دریافت اطلاعات با خطا روبرو شد.');
        }
      },
    );
  };

  const removeCoachFromList = async (id) => {
    setListLoading(true);
    const coaches = [...context.coaches];
    const coachesFilter = await coaches.filter((u) => u.id !== id);
    context.coaches = coachesFilter;
    setModalIsOpen(false);
    setListLoading(false);
    success('مربی با موفقیت از لیست حذف شد');
  };

  const removeSupervisorFromList = async (id) => {
    setListLoading(true);
    const supervisors = [...context.supervisors];
    const supervisorsFilter = await supervisors.filter((u) => u.id !== id);
    context.supervisors = supervisorsFilter;
    setModalIsOpen(false);
    setListLoading(false);
    success('سرپرست با موفقیت از لیست حذف شد');
  };

  const addCoachToList = async () => {
    let userFind = false;
    const user = context?.users.find((u) => u?.id == context.user?.id);
    if (user) {
      userFind = true;
    }

    const teams = context.teams;
    for (let team of teams) {
      if (team?.users?.find((u) => u?.id == context.user?.id)) {
        userFind = true;
      }
    }

    const leagues = context.leagues;
    for (let league of leagues) {
      if (league?.users?.find((u) => u?.id == context.user?.id)) {
        userFind = true;
      }
    }

    if (userFind) {
      error(
        `${context?.user?.name} ${context?.user?.last_name} به عنوان ورزشکار اضافه شده است.`,
      );
      return;
    }

    if (context.coaches?.length >= context?.competition?.coach_count) {
      return error(`
      تعداد مربی نمی تواند کمتر یا بیشتر از
      ${context?.competition?.coach_count}
       نفر باشد.
      `);
    }
    setListLoading(true);
    const coaches = [...context?.coaches];
    if (coaches.length > 0) {
      const coach = coaches?.findIndex((u) => u.id === context?.user?.id);
      if (coach !== -1) {
        setListLoading(false);
        return error('مربی قبلا به لیست اضافه شده است.');
      }
    }

    await coaches.push(context?.user);
    context.coaches = coaches;
    success('مربی با موفقیت اضافه شد');
    setListLoading(false);
  };

  const addSupervisorToList = async () => {
    if (context.supervisors?.length >= context?.competition?.supervisor_count) {
      return error(`
      تعداد سرپرست نمی تواند کمتر یا بیشتر از 
      ${context?.competition?.supervisor_count}
       نفر باشد.
      `);
    }
    setListLoading(true);
    const supervisors = [...context?.supervisors];
    if (supervisors.length > 0) {
      const supervisor = supervisors?.findIndex(
        (u) => u.id === context?.user?.id,
      );
      if (supervisor !== -1) {
        setListLoading(false);
        return error('سرپرست قبلا به لیست اضافه شده است.');
      }
    }
    await supervisors.push(context?.user);
    context.supervisors = supervisors;
    success('سرپرست با موفقیت اضافه شد');
    setListLoading(false);
  };

  return (
    <>
      <Form
        initialValues={{
          nat_code: '',
        }}
        validationSchema={validationSchema}
        defaultActions={false}
        onSubmit={onSubmit}
      >
        <div className='row'>
          <div className='col-12'>
            <div className='d-flex flex-column justify-content-start'>
              <p className='text-dark f-14 font-weight-bold my-2'>
                در صورت عدم وجود مربی می توانید 10 عدد صفر را به جای کد ملی
                جستجو کنید.
              </p>
            </div>
          </div>
          <div className='col-12 col-md-8'>
            <Text
              name='nat_code'
              title='کدملی *'
              serverError={serverErrors?.nat_code}
              containerClass='d-flex flex-column justify-content-start align-items-start'
              labelClass='tetx-right mx-2 f-13'
            />
          </div>
          <div className='col-12 col-md-4 mt-4'>
            {loading ? (
              <button className='btn bg-purple w-100 f-13 text-white mt-1'>
                <div
                  className='spinner-border text-white spinner-border-sm mb-1'
                  role='status'
                >
                  <span className='sr-only'></span>
                </div>
              </button>
            ) : (
              <>
                <div className='d-flex flex-row align-items-center'>
                  <button
                    type='submit'
                    className='btn bg-purple w-100 f-13 text-white mt-1'
                    onClick={() => setType(1)}
                  >
                    جستجو مربی
                  </button>
                  <button
                    onClick={() => setType(2)}
                    type='submit'
                    className='btn bg-purple w-100 f-13 text-white mt-1 mx-2'
                  >
                    جستجو سرپرست
                  </button>
                </div>
              </>
            )}
          </div>
          {context?.user?.name !== undefined && (
            <>
              <div className='col-12'>
                <div className='d-flex flex-row my-4 border-bottom border-dark'>
                  <h1 className='text-dark f-14 font-weight-bold'>
                    {type === 1 ? 'مشخصات مربی' : 'مشخصات سرپرست'}
                  </h1>
                </div>
              </div>
              <div className='col-12 col-md-3 my-3'>
                <div className='d-flex flex-row align-items-center'>
                  <span className='text-dark f-14 mx-2'>
                    نام و نام خانوادگی :{' '}
                  </span>
                  <span className='text-dark f-14 mx-2'>
                    {context?.user?.name} {context?.user?.last_name}
                  </span>
                </div>
              </div>
              <div className='col-12 col-md-3 my-3'>
                <div className='d-flex flex-row align-items-center'>
                  <span className='text-dark f-14 mx-2'>نام پدر : </span>
                  <span className='text-dark f-14 mx-2'>
                    {context?.user?.father_name}
                  </span>
                </div>
              </div>
              <div className='col-12 col-md-3 my-3'>
                <div className='d-flex flex-row align-items-center'>
                  <span className='text-dark f-14 mx-2'>کدملی : </span>
                  <span className='text-dark f-14 mx-2'>
                    {context?.user?.national_card_id}
                  </span>
                </div>
              </div>
              <div className='col-12 col-md-3 my-3'>
                <div className='d-flex flex-row align-items-center'>
                  <span className='text-dark f-14 mx-2'>شماره همراه : </span>
                  <span className='text-dark f-14 mx-2'>
                    {context?.user?.mobile}
                  </span>
                </div>
              </div>

              <div className='col-12 col-md-6 my-3'>
                <div className='d-flex flex-row align-items-center'>
                  <span className='text-dark f-14 mx-2'> آدرس : </span>
                  <span className='text-dark f-14 mx-2'>
                    {context?.user?.address}
                  </span>
                </div>
              </div>
              <div className='col-12 my-3'>
                <div className='d-flex flex-row align-items-center justify-content-end'>
                  <div className='form-group mx-2 mt-4'>
                    <button
                      onClick={
                        type == 1
                          ? addCoachToList
                          : type == 2
                          ? addSupervisorToList
                          : null
                      }
                      className='btn btn-info text-white f-13 mx-2 mt-1'
                    >
                      افزودن کاربر
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
          <SupervisorsList
            setType={setType}
            context={context}
            loading={loading}
            setModalIsOpen={setModalIsOpen}
            setModalRemoveObject={setModalRemoveObject}
          />
          {errors?.supervisor?.supervisorError?.message !== undefined && (
            <ErrorMessage
              error={errors?.supervisor?.supervisorError?.message}
              classes='mx-3 f-14'
            />
          )}
          <CoaceshList
            setType={setType}
            context={context}
            loading={loading}
            setModalIsOpen={setModalIsOpen}
            setModalRemoveObject={setModalRemoveObject}
          />
          {errors?.coach?.coachError?.message !== undefined && (
            <ErrorMessage
              error={errors?.coach?.coachError?.message}
              classes='mx-3 f-14'
            />
          )}
        </div>
      </Form>
      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modalIsOpen}
        removeItem={type === 1 ? removeCoachFromList : removeSupervisorFromList}
        removeLoading={listLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف کاربر "${modalRemoveObject?.name} ${modalRemoveObject?.last_name}" مطمئن هستید ؟`}
      />
    </>
  );
};

Step2.propType = {
  get: PropTypes.func,
  success: PropTypes.func,
  navigate: PropTypes.func,
  error: PropTypes.func,
  context: PropTypes.object,
  setActiveNextLevel: PropTypes.func,
};

export default Step2;
